<template>
  <div id="router">
    <router-view class="router-view">
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  
}
</script>

<style>
@import './assets/style/init.css';
#router{
  background-color: #411285;
  position: relative;
}
.middleScreen .flower{
  width: 90% !important;
}
.middleScreen .newflash{
  width:2.3rem  !important;
}
.middleScreen .process{
  width:2.3rem  !important;
  left: 3.5rem !important;
}
.middleScreen .voice{
  width:2.3rem  !important;
  left: 1.5rem !important;
}
.middleScreen .live{
  width:2.3rem  !important;
  top: 13.7rem !important;
  left: 11.8rem !important;
}
.middleScreen .wqsd{
  width:2.1rem  !important;
  top: 17.7rem !important;
  left: 10.5rem !important;
}
.middleScreen .industry{
  width:1.9rem  !important;
  top: 20.7rem !important;
  left: 8rem !important;
}
.middleScreen .service{
  width:1.9rem  !important;
  top: 22.6rem !important;
  left: 5rem !important;
}


.smallScreen .flower{
  width: 90% !important;
}
.smallScreen .newflash{
  width:2rem  !important;
}
.smallScreen .process{
  width:2rem  !important;
  left: 3.8rem !important;
}
.smallScreen .voice{
  width:2rem  !important;
  left: 1.8rem !important;
}
.smallScreen .live{
  width:2rem  !important;
  top: 13.7rem !important;
  left: 11.8rem !important;
}
.smallScreen .wqsd{
  width:1.9rem  !important;
  top: 17.7rem !important;
  left: 10.5rem !important;
}
.smallScreen .industry{
  width:1.8rem  !important;
  top: 20.7rem !important;
  left: 8rem !important;
}
.smallScreen .service{
  width:1.8rem  !important;
  top: 22.6rem !important;
  left: 5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue